bodyLoaded(function () {
    window.LibLenis = new Lenis({
        wheelMultiplier: document.documentElement.classList.contains('firefox') ? 1.2 : 1,
    })

    function hasScrollableParent(el) {
        while (el && el !== document.body) {
            const style = window.getComputedStyle(el)
            const overflowY = style.overflowY
            const isScrollable = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight

            if (isScrollable) {
                return true
            }
            el = el.parentElement
        }
        return false
    }

    window.addEventListener('wheel', function (e) {
        if (hasScrollableParent(e.target)) {
            e.stopImmediatePropagation()
        }
    }, { capture: true })

    function raf(time) {
        window.LibLenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    window.setScrollDetectBackground()
    window.addEventListener('scroll',scrollDetectBackground)
})
